export default __webpack_public_path__ + "static/media/agendar_ahora.9d6e5b38.png";